import type { MatchEvent } from './protocol';

/** Only the affected runner's force/cable events can change its motion. */
export function isLocalForceEvent(event: MatchEvent, playerId: string): boolean {
  return event.targetId === playerId
    && ['player_hit', 'weapon_hit', 'player_grabbed', 'player_thrown', 'player_knocked_out', 'player_knocked_off'].includes(event.type)
    || event.type === 'gadget_fired' && event.label === 'grapple' && event.sourceId === playerId;
}
